export default "__VITE_ASSET__BgrYLTVs__"